import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function OrganizationUrlRedirect() {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    // Check if this is an organization-specific path (starts with /:organization pattern)
    // Exclude admin paths and other non-organization routes
    if (
      currentPath.startsWith("/admin") ||
      currentPath === "/" ||
      currentPath.startsWith("/auth")
    ) {
      return;
    }

    // Extract the organization slug from the path
    // Expected format: /:organization/... where organization is the first path segment
    const pathSegments = currentPath
      .split("/")
      .filter((segment) => segment.length > 0);

    if (pathSegments.length === 0) {
      return;
    }

    const organizationSlug = pathSegments[0];

    if (!organizationSlug) {
      return;
    }

    // Check if the organization slug contains any uppercase characters
    const hasUppercase = /[A-Z]/.test(organizationSlug);

    if (hasUppercase) {
      // Create the normalized (lowercase) version of the organization slug
      const normalizedSlug = organizationSlug.toLowerCase();

      // Reconstruct the URL with the normalized organization slug
      const normalizedPath =
        "/" +
        normalizedSlug +
        currentPath.substring(organizationSlug.length + 1);
      const normalizedUrl =
        window.location.origin +
        normalizedPath +
        location.search +
        location.hash;

      // Redirect to the normalized URL
      // Use window.location.replace to avoid adding to browser history
      window.location.replace(normalizedUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  // This component doesn't render anything
  return null;
}
